var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1196 10.5L20.4519 3.16769C20.7999 2.82031 20.9956 2.34892 20.996 1.85722C20.9965 1.36553 20.8016 0.893795 20.4542 0.545805C20.1068 0.197814 19.6354 0.00207184 19.1437 0.0016376C18.652 0.00120337 18.1803 0.196113 17.8323 0.543489L10.5 7.8758L3.16769 0.543489C2.8197 0.195499 2.34772 0 1.85559 0C1.36346 0 0.891479 0.195499 0.543489 0.543489C0.195499 0.891479 0 1.36346 0 1.85559C0 2.34772 0.195499 2.8197 0.543489 3.16769L7.8758 10.5L0.543489 17.8323C0.195499 18.1803 0 18.6523 0 19.1444C0 19.6365 0.195499 20.1085 0.543489 20.4565C0.891479 20.8045 1.36346 21 1.85559 21C2.34772 21 2.8197 20.8045 3.16769 20.4565L10.5 13.1242L17.8323 20.4565C18.1803 20.8045 18.6523 21 19.1444 21C19.6365 21 20.1085 20.8045 20.4565 20.4565C20.8045 20.1085 21 19.6365 21 19.1444C21 18.6523 20.8045 18.1803 20.4565 17.8323L13.1196 10.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x_icon.7db73edaf1f3a344a9c4e83d2560d827.svg";
export { ForwardRef as ReactComponent };